import { Currencies } from '@orbital/games-frontend-library'
import React from 'react'

export const combinations = [
  '',
  'High Card',
  'Pair',
  'Two Pairs',
  'Three of a kind',
  'Straight',
  'Flush',
  'Full House',
  'Four of a kind',
  'Straight Flush',
  'Royal Flush',
]

export const addChipsToAnte = () => (
  <>
    ADD CHIPS TO<span>ANTE</span>
  </>
)

export const readyToPlay = () => (
  <>
    Ready To <span>PLAY</span>
  </>
)

export const winnerCombination = (
  wintype: number,
  currency: string,
  state: number,
  totalWin: string,
  precision:number
) => (
  <>
    {state === 11 ? (
      <p>Tie</p>
    ) : (
      <>
        <p>
          {combinations[wintype]}
          {state === 6 && <span>wins</span>}
          {state === 5 && (
            <span>
              wins {Currencies[currency]}
              {totalWin && (+totalWin).toFixed(precision)}
            </span>
          )}
        </p>
      </>
    )}
  </>
)
